import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import _, { forEach, set } from 'lodash';
import tokenService from "../../../Common/tokenDecoder";
import xlsx from 'json-as-xlsx';

export const RouteListing = ({ routeData, handleClick, editEnabled, groups,operationEntity,collectionCategory, routes }) => {
    
    
    const [route, setRoute] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const contentRowNames = ["collectionPointCode", "collectionPointName", "isActive"];
    const csvHeaders = [
        { label: "CollectionPoint Code", value: "collectionPointCode" },
        { label: "CollectionPoint Name", value: "collectionPointName" },
        { label: "Is Active", value: "isActive" }
    ];
  

    useEffect(() => {
        trackPromise(
            setRouteData()
            )
    }, [routeData]);

    async function setRouteData() {
        destroyDataTable();
        await setRoute(routeData);

        const comlpeteData = [...routeData];
        const result = [...comlpeteData]
        result.forEach(x => {
            x.isActive = (x.isActive == true ? "Active" : "InActive");
        });
        setCsvData(result)

        createDataTable();
    }
   
    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ?
                (da[row] === true ? <td key={index}>Inactive</td> : <td key={index}>Active</td>)
                : <td key={index}>{da[row] + " "}</td>
            )
        )
    });
    
    
    function createFile() {
        var settings = {
            sheetName: 'Routes',
            fileName: 'Routes',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointCode: "Group :" + groups[routes.groupID],
            collectionPointName: "Operation Entity : " + operationEntity[routes.operationEntityID],
            isActive: "Collection Category: " + (collectionCategory[routes.collectionCatagoryID] === undefined ? "All Collection Category" : collectionCategory[routes.collectionCatagoryID])
        }
        var newRow2 = {
             collectionPointCode: "Generated date/time : " + new Date().toLocaleString(),
             collectionPointName: "Generated user : " + tokenService.getUserNameFromToken()
        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                         
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Route Code</th>
                                        <th>Route Name</th>
                                        <th>Status</th>
                                        {editEnabled ? <th>Actions</th>: null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {route.map((data, i) => {
                                        return (
                                            <tr key={i}>
                                                {content(data)}
                                                {editEnabled ? <td 
                                                    onClick={() => handleClick(data)} 
                                                    style={{ cursor: "pointer" }}><i class="far fa-edit"></i>
                                                </td> : null}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                    </div>
                        </div>
                    </div>
                </div>
            </div>
        
    </Fragment>
    )
}